var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"infoBody"},[_c('span',{staticClass:"msgSpan"},[_vm._v(_vm._s(_vm.messageBody))])])}
var staticRenderFns = []

export { render, staticRenderFns }